import { Box, ThemeProvider, createTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Loader from '../../components/loader';
import { POST_BY_IDS_API } from '../../api/endpoint';
import { PostDetail } from '../../types';
import PostDetailDialog from './post-detail';
import axiosInstance from '../../api/axiosConfig';
import createAxiosInstance from '../../api/axiosConfig';

const theme = createTheme({
  typography: {
    fontFamily: 'Baloo2'
  }
});

const Post: React.FC = () => {
  const { postId } = useParams<{ postId: string }>();
  const navigate = useNavigate();
  const [postDetail, setPostDetail] = useState<PostDetail | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPostDetails = async () => {
    try {
      const axiosInstance = createAxiosInstance(false);
      const response = await axiosInstance.get(`${POST_BY_IDS_API}${postId}`);
      setPostDetail(response.data.data[0]);
      setLoading(false);
    } catch {
      setError('Failed to fetch post details.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPostDetails();
  }, [postId]);

  if (loading) return <Loader />;
  if (error) return <Box>{error}</Box>;

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <PostDetailDialog open={true} onClose={handleClose} postDetail={postDetail} />
      </Box>
    </ThemeProvider>
  );
};

export default Post;
